import { TextField, Theme } from '@mui/material';
import { FC, ChangeEvent, FocusEvent } from 'react';
import { FormControl, createStyles, makeStyles } from '../uiLibraryImports';
import { FullNameTypes } from './fullNameTypes';
import './fullName.scss';

const FullName: FC<FullNameTypes> = (props: FullNameTypes) => {
    const {
        fullName,
        onChangeFullName,
        error,
        errorMessage,
        onBlur,
        id,
        autoComplete = 'on',
        helperTextAlign = 'right',
        helperText,
        placeholder
    } = props;

    const useStyles = makeStyles((_: Theme) =>
        createStyles({
            cssOutlinedInput: {
                height: '2.75rem !important',
                width: '100% !important',
                background: 'rgba(38, 35, 58, 0.5)',
                color: 'white',
                '&$cssFocused $notchedOutline': {
                    borderColor: 'rgba(71, 154, 235, 1) !important'
                }
            },
            cssFocused: {},
            notchedOutline: {
                borderColor: error ? 'rgba(241, 96, 93, 1) !important' : 'rgba(255, 255, 255, 0.25) !important'
            },
            helperText: {
                textAlign: helperTextAlign,
                marginRight: 0,
                color: error ? 'rgba(241, 96, 93, 1) !important' : 'rgba(255, 255, 255, 0.50) !important',
                marginLeft: '0 !important'
            }
        })
    );

    const classes = useStyles();

    return (
        <FormControl variant="outlined">
            <TextField
                id={id}
                className="full-name"
                type="text"
                value={fullName}
                error={error}
                helperText={errorMessage || helperText}
                onChange={(e: ChangeEvent<HTMLInputElement>): void =>
                    onChangeFullName && onChangeFullName(e.target.value)
                }
                onBlur={(e: FocusEvent<HTMLInputElement>): void => onBlur && onBlur(e.target.value)}
                FormHelperTextProps={{
                    className: classes.helperText
                }}
                placeholder={placeholder}
                variant="outlined"
                InputProps={{
                    autoComplete,
                    classes: {
                        root: classes.cssOutlinedInput,
                        focused: classes.cssFocused,
                        notchedOutline: classes.notchedOutline
                    }
                }}
            />
        </FormControl>
    );
};

export default FullName;
